import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import lodash from 'lodash';

import { getTimezoneOffset } from '../../selectors/index';

class DateTime extends Component {
    render() {
        const value = this.formatValue();
        return (
            <span className={this.props.className}>{value}</span>
        );
    }

    formatValue() {
        const { value } = this.props;
        const format = this.getFormat();

        return !lodash.isNil(value) ? this.getDateTimeOffset(value, format) : '';
    }

    // Will automatically apply timezone offset to DateTime. 
    // DateOnly timezone offset is configurable.
    getDateTimeOffset(value, format) {
        const { time, timezoneOffset, inputFormat } = this.props;

        if(timezoneOffset) {
            return time
                ? moment(value, inputFormat).utcOffset(timezoneOffset).format(format)
                : this.getDateOnlyOffset(value, format, timezoneOffset);
        }
    }

    getDateOnlyOffset(value, format, timezoneOffset) {
        const { applyTimezoneOffset, inputFormat } = this.props;

        const momentFunc = this.props.isUTC ? moment.utc : moment;

        return applyTimezoneOffset
            ? momentFunc(value, inputFormat).utcOffset(timezoneOffset).format(format)
            : momentFunc(value, inputFormat).format(format);
    }

    getFormat() {
        const { time, format } = this.props;
        if(format) {
            return format;
        }
        return time ? 'DD MMM YYYY hh:mm A' : 'DD MMM YYYY';
    }
}

DateTime.propTypes = {
    value: PropTypes.any.isRequired,
    time: PropTypes.bool
};

export default connect((state, props) => {
    return {
        timezoneOffset: getTimezoneOffset(state),
    };
}, {

})(DateTime);
